import React from "react";

const PageLoader = () => {
  return (
    <div className="vh-100" style={{ backgroundColor: '#000000', width: '100%', height: '100vh' }}></div>
  );
};

export default PageLoader;